module.exports = __webpack_public_path__ + "img/pulpito.193235d1.svg";